import { gql } from '@parkchirp/api-client';

export const UPDATE_FACILITY_AREA_V2: any = gql`
  mutation updateFacilityArea(
    $id: Int!
    $name: String!
    $code: String!
    $organizationId: Int!
  ) {
    updateFacilityArea(
      id: $id
      name: $name
      code: $code
      organizationId: $organizationId
    )
  }
`;

export const DELETE_FACILITY_AREA_V2: any = gql`
    mutation deleteFacilityArea($id: Int!, $organizationId: Int!) {
        deleteFacilityArea(id: $id, organizationId: $organizationId)
    }
`;

export const CREATE_FACILITY_AREA_V2: any = gql`
  mutation createFacilityArea(
    $name: String!
    $code: String!
    $organizationId: Int!
  ) {
    createFacilityArea(
      name: $name
      code: $code
      organizationId: $organizationId
    )
  }
`;

export const CREATE_FACILITY_BRANCH_V2: any = gql`
  mutation createFacilityBranch(
    $name: String!
    $code: String!
    $areaId: Int!
    $organizationId: Int!
  ) {
    createFacilityBranch(
      name: $name
      code: $code
      areaId: $areaId
      organizationId: $organizationId
    )
  }
`;

export const UPDATE_FACILITY_BRANCH_V2: any = gql`
  mutation updateFacilityBranch(
    $id: Int!
    $name: String!
    $code: String!
    $areaId: Int!
    $organizationId: Int!
  ) {
    updateFacilityBranch(
      id: $id
      name: $name
      code: $code
      areaId: $areaId
      organizationId: $organizationId
    )
  }
`;

export const DELETE_FACILITY_BRANCH_V2: any = gql`
  mutation deleteFacilityBranch($id: Int!, $organizationId: Int!) {
    deleteFacilityBranch(id: $id, organizationId: $organizationId)
  }
 `;

export const UPDATE_PRODUCT_CODE: any = gql`
    mutation updateProductCode(
            $id: Int!,
            $name: String!,
            $code: String!,
            $organizationId: Int!,
            $description: String
        ) {
        updateProductCode(id: $id, name: $name, code: $code, organizationId: $organizationId, description: $description)
    }
`;
export const DELETE_PRODUCT_CODE: any = gql`
  mutation deleteProductCode($id: Int!, $organizationId: Int!) {
    deleteProductCode(id: $id, organizationId: $organizationId)
  }
`;

export const CREATE_PRODUCT_CODE: any = gql`
  mutation createProductCode(
    $name: String!
    $code: String!
    $organizationId: Int!
    $description: String
  ) {
    createProductCode(
      name: $name
      code: $code
      organizationId: $organizationId
      description: $description
    )
  }
`;

export const DELETE_OWNER_FROM_FACILITY = gql`
mutation deleteOwnerFromFacility($ownerId: String!, $facilityId: String!) {
  deleteOwnerFromFacility(ownerId: $ownerId, facilityId: $facilityId)
}
`;

export const ADD_OWNER_TO_FACILITY = gql`
mutation addOwnerToFacility($email: String!, $facilityId: String!) {
  addOwnerToFacility(email: $email, facilityId: $facilityId) {
    userId
  }
}
`;

export const UPDATE_FACILITY: any = gql`
  mutation updateFacility($facility: FacilityInput) {
    updateFacility(facility: $facility) {
      id
    }
  }
`;

export const ADD_FACILITY_FROM_WORDPRESS = gql`
  mutation addFacilityFromWordpress($facilityName: String!) {
    addFacilityFromWordpress(facilityName: $facilityName)
  }
`;

export const UPDATE_FACILITY_FROM_WORDPRESS = gql`
  mutation updateFacilityFromWordpress($facilityId: String!) {
    updateFacilityFromWordpress(facilityId: $facilityId)
  }
`;

export const ADD_BARCODES_TO_PARKERS_FOR_FACILITY = gql`
  mutation addBarcodesToParkersForFacility($facilityId: String!) {
    addBarcodesToParkersForFacility(facilityId: $facilityId)
  }
`;

export const SYNC_ALL_CACHES_BY_FACILITY = gql`
  mutation syncAllCachesByFacility($facilityId: String!) {
    syncAllCachesByFacility(facilityId: $facilityId)
  }
`;

export const UPDATE_MY_ACCOUNT_FACILITY_SETTINGS: any = gql`
mutation updateMyAccountFacilitySettings($facilityId: String!, $showParkerTermination: Boolean!, $showParkerAddition: Boolean!) {
  updateMyAccountFacilitySettings(facilityId: $facilityId, showParkerTermination: $showParkerTermination, showParkerAddition: $showParkerAddition)
}
`;

export const UPDATE_SUBSCRIPTIONS_AUTO_APPLY_CREDITS_BY_FACILITY = gql`
  mutation updateSubscriptionsAutoApplyCreditsByFacility($facilityId: String!, $autoApplyCredits: Boolean!) {
    updateSubscriptionsAutoApplyCreditsByFacility(
      facilityId: $facilityId
      autoApplyCredits: $autoApplyCredits
    )
  }
`;

export const CREATE_FACILITY_DISTRICT_V2: any = gql`
  mutation createFacilityDistrict(
    $name: String!
    $code: String!
    $branchId: Int!
    $organizationId: Int!
  ) {
    createFacilityDistrict(
      name: $name
      code: $code
      branchId: $branchId
      organizationId: $organizationId
    )
  }
`;

export const UPDATE_FACILITY_DISTRICT_V2: any = gql`
  mutation updateFacilityDistrict(
    $id: Int!
    $name: String!
    $code: String!
    $branchId: Int!
    $organizationId: Int!
  ) {
    updateFacilityDistrict(
      id: $id
      name: $name
      code: $code
      branchId: $branchId
      organizationId: $organizationId
    )
  }
`;

export const DELETE_FACILITY_DISTRICT_V2: any = gql`
  mutation deleteFacilityDistrict($id: Int!, $organizationId: Int!) {
    deleteFacilityDistrict(id: $id, organizationId: $organizationId)
  }
`;

export const UPDATE_RATE_CODE: any = gql`
  mutation updateRateCode(
    $id: Int!
    $name: String!
    $code: String!
    $organizationId: Int!
    $description: String
  ) {
    updateRateCode(
      id: $id
      name: $name
      code: $code
      organizationId: $organizationId
      description: $description
    )
  }
`;
export const DELETE_RATE_CODE: any = gql`
  mutation deleteRateCode($id: Int!, $organizationId: Int!) {
    deleteRateCode(id: $id, organizationId: $organizationId)
  }
`;

export const CREATE_RATE_CODE: any = gql`
  mutation createRateCode(
    $name: String!
    $code: String!
    $organizationId: Int!
    $description: String
  ) {
    createRateCode(
      name: $name
      code: $code
      organizationId: $organizationId
      description: $description
    )
  }
`;

export const CREATE_CONTRACT = gql`
  mutation createContract(
    $contractName: String!
    $contractType: ContractTypeEnum!
    $documentType: DocumentTypeEnum!
    $ownerLLC: String!
    $startDate: String!
    $expirationDate: String!
    $facilityId: String!
    $filePath: String
    $fileType: String
    $fileName: String
  ) {
    createContract(
      contractName: $contractName
      contractType: $contractType
      documentType: $documentType
      ownerLLC: $ownerLLC
      startDate: $startDate
      expirationDate: $expirationDate
      facilityId: $facilityId
      filePath: $filePath
      fileType: $fileType
      fileName: $fileName
    ) {
      contractId
      keyName
    }
  }
`;

export const UPDATE_CONTRACT = gql`
  mutation updateContract(
    $contractId: String!
    $facilityId: String!
    $contractName: String
    $contractType: ContractTypeEnum
    $documentType: DocumentTypeEnum
    $ownerLLC: String
    $startDate: String
    $expirationDate: String
    $filePath: String
    $fileType: String
    $fileName: String
  ) {
    updateContract(
      contractId: $contractId
      facilityId: $facilityId
      contractName: $contractName
      contractType: $contractType
      documentType: $documentType
      ownerLLC: $ownerLLC
      startDate: $startDate
      expirationDate: $expirationDate
      filePath: $filePath
      fileType: $fileType
      fileName: $fileName
    ) {
      keyName
    }
  }
`;

export const DELETE_CONTRACT = gql`
  mutation deleteContract($contractId: String!) {
    deleteContract(contractId: $contractId)
  }
`;

export const CREATE_GL_CODE_V2 = gql`
  mutation createGLCode(
    $glType: GLTypeEnum!
    $glCode: String!
    $organizationId: Int!
    $productCodeId: Int
    $contractType: GLCodeContractTypeEnum
    $rateCodeId: Int
    $facilityId: String
  ) {
    createGLCode(
      glType: $glType
      glCode: $glCode
      organizationId: $organizationId
      productCodeId: $productCodeId
      contractType: $contractType
      rateCodeId: $rateCodeId
      facilityId: $facilityId
    )
  }
`;

export const UPDATE_GL_CODE_V2 = gql`
  mutation updateGLCode(
    $glCodeId: String!
    $glType: GLTypeEnum!
    $glCode: String!
    $organizationId: Int!
    $productCodeId: Int
    $contractType: GLCodeContractTypeEnum
    $rateCodeId: Int
    $facilityId: String
  ) {
    updateGLCode(
      glCodeId: $glCodeId
      glType: $glType
      glCode: $glCode
      organizationId: $organizationId
      productCodeId: $productCodeId
      contractType: $contractType
      rateCodeId: $rateCodeId
      facilityId: $facilityId
    )
  }
`;

export const CREATE_SUBSCRIPTION_V2 = gql`
  mutation createSubscription(
    $billingProfileId: String!
    $payor: PayorInput!
    $subscription: CreateSubscriptionInput!
    $billingEmails: [BillingEmailsInput]!
  ) {
    createSubscription(
      billingProfileId: $billingProfileId
      payor: $payor
      subscription: $subscription
      billingEmails: $billingEmails
    ) {
      id
    }
  }
`;

export const DELETE_GL_CODE_V2 = gql`
  mutation deleteGLCode(
    $glCodeId: String!
    $organizationId: Int!
    ) {
      deleteGLCode(
        glCodeId: $glCodeId
        organizationId: $organizationId
      )
  }
`;

export const DEACTIVATE_RATE_V2 = gql`
  mutation deactivateRate($rateId: ID!) {
    deactivateRate(rateId: $rateId)
  }
`;

export const DELETE_DEPOSIT_DOCUMENT_V2 = gql`
  mutation deleteDepositDocument($id: String!, $path: String!) {
    deleteDepositDocument(id: $id, path: $path)
  }
`;

export const PROCESS_PAYMENT_V2 = gql`
  mutation processPaymentBatch($paymentBatchId: Int!) {
    processPaymentBatch(paymentBatchId: $paymentBatchId)
  }
`;

export const PROCESS_ADJUSTMENTS = gql`
  mutation processAdjustmentBatch($adjustmentBatchId: Int!) {
    processAdjustmentBatch(adjustmentBatchId: $adjustmentBatchId)
  }
`;

export const DEACTIVATE_FEE_V2 = gql`
  mutation deactivateFee($feeId: ID!) {
    deactivateFee(feeId: $feeId) {
      success
    }
  }
`;

export const CREATE_INVOICE = gql`
  mutation adminCreateInvoice(
    $subscriptionId: String!,
    $type: InvoiceTypeEnum,
    $invoiceDueDate: String!,
    $invoiceBillingDate: String,
    $notes: String,
    $detailNotes: String,
    $lineItems: [LineItemInput]!,
    $parkingPeriodMonth: String,
    $parkingPeriodYear: Int,
    $attachments: [Attachment!],
    $sendEmail: Boolean,
    $mailInvoice: Boolean,
    $isDraft: Boolean,
  ) {
      adminCreateInvoice(
        subscriptionId: $subscriptionId,
        type: $type,
        invoiceDueDate: $invoiceDueDate,
        invoiceBillingDate: $invoiceBillingDate,
        notes: $notes,
        detailNotes: $detailNotes,
        lineItems: $lineItems,
        parkingPeriodMonth: $parkingPeriodMonth,
        parkingPeriodYear: $parkingPeriodYear,
        attachments: $attachments,
        sendEmail: $sendEmail,
        mailInvoice: $mailInvoice,
        isDraft: $isDraft,
      )
    }
`;

export const UPDATE_DRAFT_INVOICE = gql`
  mutation updateDraftInvoice(
    $subscriptionId: String!,
    $type: InvoiceTypeEnum,
    $invoiceDueDate: String!,
    $notes: String,
    $detailNotes: String,
    $invoiceBillingDate: String,
    $lineItems: [LineItemInput]!,
    $parkingPeriodMonth: String,
    $parkingPeriodYear: Int,
    $attachments: [Attachment!],
    $sendEmail: Boolean,
    $mailInvoice: Boolean,
    $isDraft: Boolean,
    $invoiceId: String!,
    $createdByDailyReport: Boolean,
    $readableId: String!
  ) {
      updateDraftInvoice(
        subscriptionId: $subscriptionId,
        type: $type,
        invoiceDueDate: $invoiceDueDate,
        invoiceBillingDate: $invoiceBillingDate,
        notes: $notes,
        detailNotes: $detailNotes,
        lineItems: $lineItems,
        parkingPeriodMonth: $parkingPeriodMonth,
        parkingPeriodYear: $parkingPeriodYear,
        attachments: $attachments,
        sendEmail: $sendEmail,
        mailInvoice: $mailInvoice,
        isDraft: $isDraft,
        invoiceId: $invoiceId,
        createdByDailyReport: $createdByDailyReport,
        readableId: $readableId,
      )
    }
`;

export const DELETE_SUBSCRIPTION = gql`
  mutation deleteSubscription(
    $subscriptionId: String!
  ) {
    deleteSubscription(
      subscriptionId: $subscriptionId
    )
  }
`;

export const REVERSE_PAYMENT = gql`
  mutation reversePayment(
    $paymentId: String!,
    $applicationDate: String,
    $reversalType: ReversalTypeEnum!
    ) {
      reversePayment(
        paymentId: $paymentId,
        applicationDate: $applicationDate,
        reversalType: $reversalType
      ) {
        invoice {
          id
        }
        overpaymentCredit {
          readableId
        }
        creditReversed
      }
    }
`;

export const CREATE_USER = gql`
  mutation createUser(
    $email: String!,
    $firstName: String!,
    $lastName: String!,
    $roleId: Int!,
    $facilities: [String]!,
    $facilityAreas: [Int]!,
    $facilityBranches: [Int]!,
    $facilityDistricts: [Int]!,
    $externalApi: [UserExternalApiInput]
  ) {
    createUser(
      email: $email,
      firstName: $firstName,
      lastName: $lastName,
      roleId: $roleId,
      facilities: $facilities,
      facilityAreas: $facilityAreas,
      facilityBranches: $facilityBranches,
      facilityDistricts: $facilityDistricts,
      externalApi: $externalApi
    ) {
      userId
    }
  }
`;

export const UPDATE_USER = gql`
  mutation updateUser(
    $id: String!,
    $firstName: String!,
    $lastName: String!,
    $roleId: Int!
    $facilities: [String]!,
    $facilityAreas: [Int]!,
    $facilityBranches: [Int]!,
    $facilityDistricts: [Int]!,
    $externalApi: [UserExternalApiInput]
  ) {
    updateUser(
        id: $id,
        firstName: $firstName,
        lastName: $lastName,
        roleId: $roleId
        facilities: $facilities,
        facilityAreas: $facilityAreas,
        facilityBranches: $facilityBranches,
        facilityDistricts: $facilityDistricts,
        externalApi: $externalApi
    )
  }
`;

export const REMOVE_USER_FROM_ORGANIZATION = gql`
  mutation removeUserFromOrganization($userId: String!) {
    removeUserFromOrganization(userId: $userId)
  }
`;

export const UPDATE_PAYMENT_GROUP_NOTES = gql`
  mutation updatePaymentGroupNotes(
      $id: Int!
      $notes: String!
  ) {
    updatePaymentGroupNotes(
         id: $id
         notes: $notes
      )
    }
`;

export const DELETE_USER = gql`
  mutation deleteUser(
    $id: String!,
  ) {
    deleteUser(
        id: $id,
    )
  }
`;

export const DELETE_ADJUSTMENT_BATCH_DETAIL = gql`
    mutation deleteAdjustmentBatchDetail(
        $adjustmentBatchDetailId: Int!
        $totalAdjustmentAmount: Int!
        $adjustmentBatchId: Int!
    ) {
        deleteAdjustmentBatchDetail(
            adjustmentBatchDetailId: $adjustmentBatchDetailId
            totalAdjustmentAmount: $totalAdjustmentAmount
            adjustmentBatchId: $adjustmentBatchId
        )
    }
`;

export const DELETE_DRAFT_INVOICE = gql`
    mutation deleteDraftInvoice(
        $id: String!
    ) {
        deleteDraftInvoice(
            id: $id
        )
    }
`;

export const CREATE_ORGANIZATION_INVOICE_TEMPLATES = gql`
    mutation createOrganizationInvoiceTemplates (
        $organizationId: Int!
        $invoiceTemplateIds: [Int]!
    ) {
      createOrganizationInvoiceTemplates(
        organizationId: $organizationId
        invoiceTemplateIds: $invoiceTemplateIds
        )
    }
`;

export const CREATE_FACILITY_INVOICE_TEMPLATES = gql`
    mutation createFacilityInvoiceTemplates (
        $facilityId: String!
        $invoiceTemplateIds: [Int]!
    ) {
      createFacilityInvoiceTemplates(
        facilityId: $facilityId
        invoiceTemplateIds: $invoiceTemplateIds
        )
    }
`;

export const CREATE_BULK_EMAIL = gql`
  mutation createBulkEmail(
    $facilityId: String!
    $emailSubject: String!
    $emailContent: String!
    $attachmentsS3BucketDir: String!
  ) {
    createBulkEmail(
      facilityId: $facilityId
      emailSubject: $emailSubject
      emailContent: $emailContent
      attachmentsS3BucketDir: $attachmentsS3BucketDir
    ) {
      bulkEmailId
    }
  }
`;

export const CREATE_BULK_EMAIL_ADDRESSES = gql`
  mutation createBulkEmailAddresses(
    $bulkEmailId: Int!
    $customerType: String!
    $ids: [String!]!
  ) {
    createBulkEmailAddresses(
      bulkEmailId: $bulkEmailId
      customerType: $customerType
      ids: $ids
    )
  }
`;

export const CREATE_BULK_PAYMENT_UPLOAD_FILE = gql`
 mutation createBulkPaymentUploadFile(
        $s3Key: String!
        $organizationId: Int!
        $paymentId: String!
        $paymentType: String!
        $paymentAmount: Int!
        $applicationDate: String!
    ) {
        createBulkPaymentUploadFile (
            s3Key: $s3Key
            organizationId: $organizationId
            paymentId: $paymentId
            paymentType: $paymentType
            paymentAmount: $paymentAmount
            applicationDate: $applicationDate
        )
    }
`;

export const CREATE_PAYMENT_BATCH_V2 = gql`
    mutation createPaymentBatch(
        $details: [BatchDetailsInput]
        $status: String!
        $subtotalCash: Int
        $subtotalCreditsApplied: Int
        $subtotalCreditsCreated: Int
        $grandTotal: Int
        $postedAt: String,
        $documents: [BatchDepositDocumentInput]
    ) {
        createPaymentBatch(
            details: $details
            status: $status
            subtotalCash: $subtotalCash
            subtotalCreditsApplied: $subtotalCreditsApplied
            subtotalCreditsCreated: $subtotalCreditsCreated
            grandTotal: $grandTotal
            postedAt: $postedAt,
            documents:  $documents,
        )
    }
`;

export const UPDATE_PAYMENT_BATCH_V2 = gql`
    mutation updatePaymentBatch(
        $id: Int!
        $details: [BatchDetailsInput]
        $status: String!
        $subtotalCash: Int
        $subtotalCreditsApplied: Int
        $subtotalCreditsCreated: Int
        $grandTotal: Int
        $postedAt: String,
        $documents: [BatchDepositDocumentInput]
    ) {
        updatePaymentBatch(
            id: $id
            details: $details
            status: $status
            subtotalCash: $subtotalCash
            subtotalCreditsApplied: $subtotalCreditsApplied
            subtotalCreditsCreated: $subtotalCreditsCreated
            grandTotal: $grandTotal
            postedAt: $postedAt,
            documents:  $documents,
        )
    }
`;

export const DELETE_PAYMENT_BATCH_DETAIL_V2 = gql`
    mutation deletePaymentBatchDetail(
        $paymentBatchId: Int!
        $paymentBatchDetailId: Int!
        $cashTotal: Int!
        $creditsAppliedTotal: Int!
        $creditsCreatedTotal: Int!
    ) {
        deletePaymentBatchDetail(
          paymentBatchId: $paymentBatchId
          paymentBatchDetailId: $paymentBatchDetailId
          cashTotal: $cashTotal
          creditsAppliedTotal: $creditsAppliedTotal
          creditsCreatedTotal: $creditsCreatedTotal
        )
    }
`;

export const CREATE_ADJUSTMENT_BATCH = gql`
    mutation createAdjustmentBatch(
        $details: [AdjustmentBatchDetailsInput]
        $status: String!
        $totalAdjustmentAmount: Int
        $postedAt: String,
        $documents: [BatchDepositDocumentInput]
    ) {
        createAdjustmentBatch(
            details: $details
            status: $status
            totalAdjustmentAmount: $totalAdjustmentAmount
            postedAt: $postedAt
            documents:  $documents
        )
    }
`;

export const UPDATE_ADJUSTMENT_BATCH = gql`
    mutation updateAdjustmentBatch(
        $id: Int!
        $details: [AdjustmentBatchDetailsInput]
        $status: String!
        $totalAdjustmentAmount: Int
        $postedAt: String,
        $documents: [BatchDepositDocumentInput]
    ) {
        updateAdjustmentBatch(
            id: $id
            details: $details
            status: $status
            totalAdjustmentAmount: $totalAdjustmentAmount
            postedAt: $postedAt
            documents:  $documents
        )
    }
`;

export const UPDATE_PAYMENT_BATCH_STATUS_V2 = gql`
    mutation updatePaymentBatchStatus(
        $id: Int!
        $status: String!
        $rejectionReason: String
    ) {
        updatePaymentBatchStatus(
            id: $id
            status: $status
            rejectionReason: $rejectionReason
        )
    }
 `;

export const UPDATE_HOURLY_TERMS_AND_CONDITIONS = gql`
  mutation updateHourlyTermsAndConditions(
    $id: String
    $default: Boolean
    $name: String!
    $cityId: String!
    $text: String!
    $organizationId: Int!
  ) {
    updateHourlyTermsAndConditions(
      id: $id
      default: $default
      name: $name
      cityId: $cityId
      text: $text
      organizationId: $organizationId
    )
  }
`;

export const UPDATE_ORG_ALERT_CONFIGURATIONS = gql`
  mutation updateOrgAlertConfigurations(
    $orgId: Int!
    $alerts: [AlertConfigInput]
  ) {
    updateOrgAlertConfigurations(
      orgId: $orgId
      alerts: $alerts
    )
  }
`;

export const SYNC_FACILITY_GEO_LOCATIONS = gql`
  mutation syncFacilityGeoLocations {
    syncFacilityGeoLocations
  }
`;

export const ENABLE_RESERVED_SPACE_INVENTORY = gql`
  mutation enableReservedSpaceInventory(
  	$input: EnableReservedSpaceInventoryInput!
  ) {
	enableReservedSpaceInventory(input: $input)
  }
`;

export const UPDATE_FACILITY_AUTO_ACCESS_CONTROLS = gql`
  mutation updateFacilityAutoAccessControls(
    $facilityId: String!
    $autoAccessEnabled: Boolean!
    $autoAccessDay: String
    $autoAccessDayType: String
    $autoAccessTime: String
  ) {
    updateFacilityAutoAccessControls(
      facilityId: $facilityId
      autoAccessEnabled: $autoAccessEnabled
      autoAccessDay: $autoAccessDay
      autoAccessDayType: $autoAccessDayType
      autoAccessTime: $autoAccessTime
    )
  }
`;
